<template>
  <div class="tw-bg-white tw-rounded-xl tw-shadow-md tw-p-5">
    <div class="tw-flex tw-items-center tw-justify-between">
      <div>
        <p class="tw-text-xs tw-font-medium tw-tracking-wide tw-text-slate-500 tw-uppercase">
          Quote number
        </p>
        <p class="tw-mt-1 tw-text-lg tw-font-semibold tw-text-slate-900">
          {{ jobNumber || reference }}
        </p>
      </div>
      <div class="tw-text-right">
      <p class="tw-text-xs tw-font-medium tw-text-slate-500 tw-uppercase">
        Status
      </p>
      <span
        class="tw-inline-flex tw-items-center tw-rounded-full tw-px-3 tw-py-1 tw-text-xs tw-font-medium"
        :class="statusPillClass"
      >
        {{ statusLabel }}
      </span>
      <p
        v-if="!canCheckout"
        class="tw-mt-1 tw-text-[11px] tw-font-medium tw-text-slate-500"
      >
        Sign-off unavailable
      </p>
    </div>
    </div>
    <p class="tw-mt-3 tw-text-xs tw-text-slate-500 tw-border-t tw-border-slate-100 tw-pt-3">
      This quote is valid for 30 days from the date of issue.
    </p>
  </div>
</template>

<script>
export default {
  name: 'QuoteStatusCard',
  props: {
    reference: {
      type: String,
      default: ''
    },
    jobNumber: {
      type: String,
      default: ''
    },
    statusLabel: {
      type: String,
      default: ''
    },
    statusPillClass: {
      type: String,
      default: ''
    },
    canCheckout: {
      type: Boolean,
      default: true
    }
  }
}
</script>
